import { Link } from 'react-router-dom';
import type { Manga } from '@/mocks/manga';

interface MangaCardProps {
  manga: Manga;
}

export default function MangaCard({ manga }: MangaCardProps) {
  return (
    <Link
      to={`/article/${manga.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200">
        <img
          src={manga.coverImage}
          alt={`${manga.title} - 免费耽美漫画在线阅读`}
          title={`${manga.title} - 耽美漫画网`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <p className="text-xs text-white line-clamp-2">{manga.description}</p>
        </div>
        {manga.status === '已完结' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-[10px] font-medium bg-accent-500 text-background-50 rounded-full">
            已完结
          </span>
        )}
        {manga.status === '连载中' && manga.featured && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-[10px] font-medium bg-primary-500 text-background-50 rounded-full">
            热门
          </span>
        )}
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm font-medium text-foreground-800 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {manga.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-0.5">{manga.author}</p>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="flex items-center gap-0.5 text-xs text-accent-500">
            <i className="ri-star-fill text-[10px]"></i>
            {manga.rating}
          </span>
          <span className="text-xs text-foreground-400">
            {manga.views > 10000 ? `${(manga.views / 10000).toFixed(1)}万` : manga.views}阅读
          </span>
        </div>
      </div>
    </Link>
  );
}